import { autoinject } from "aurelia-dependency-injection";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/attachment/attachment.constants";
import {
    GetEntityAttachmentsResponse, EntityAttachmentModel,
    AddEntityAttachmentsRequest, AddEntityAttachmentsResponse,
    RemoveEntityAttachmentsRequest, RemoveEntityAttachmentsResponse,
    GetEntityAttachmentsRequest, GetEntityAttachmentUrlResponse, RemoveCorrespondenceAttachmentsRequest
} from "../../models/attachment/attachment.models";
import { DocumentsCountResponse } from "../../models/vessels/vessel.models";
import { AttachmentTypeModel } from "@rightship-tech/common-ui/models/attachments.models";

@autoinject
export class AttachmentClientService {

    constructor(private requestClient: RequestClientService) {
    }

    public getAttachments(request: GetEntityAttachmentsRequest): Promise<GetEntityAttachmentsResponse> {
        return this.requestClient.post(Urls.GetAttachments, {}, request);
    }

    public getAttachment(entityAttachmentId: number): Promise<EntityAttachmentModel> {
        return new Promise<EntityAttachmentModel>((resolve, reject) => {
            this.getAttachments({ id: entityAttachmentId }).then((response: GetEntityAttachmentsResponse) => {
                resolve(response.entityAttachments[0]);
            }).catch((response) => {
                reject(response);
            });
        });
    }

    public getSharedAccessSignatureToken(entityAttachmentId: number, downloadFile: boolean): Promise<string> {
        return this.requestClient.get(Urls.GetSharedAccessSignatureToken, { entityAttachmentId, downloadFile });
    }

    public getSharedAccessSignatureTokenFromPath(url: string, fileName:string): Promise<string> {
        return this.requestClient.get(Urls.GetSharedAccessSignatureTokenFromPath, { url, fileName });
    }

    public getEntityAttachmentUrl(entityAttachmentId: number, downloadFile: boolean): Promise<GetEntityAttachmentUrlResponse> {
        return this.requestClient.get(Urls.GetEntityAttachmentUrl, { entityAttachmentId, downloadFile });
    }

    public saveAttachments(request: AddEntityAttachmentsRequest): Promise<AddEntityAttachmentsResponse> {
        return this.requestClient.postFormData(Urls.SaveAttachments, request);
    }

    public deleteAttachments(request: RemoveEntityAttachmentsRequest): Promise<RemoveEntityAttachmentsResponse> {
        return this.requestClient.post(Urls.DeleteAttachments, {}, request);
    }

    public deleteCorrespondenceAttachments(request: RemoveCorrespondenceAttachmentsRequest): Promise<RemoveEntityAttachmentsResponse> {
        return this.requestClient.post(Urls.DeleteCorrespondenceAttachments, {}, request);
    }

    public getDocumentCountsForEntity(entityId: number, entityTypeId: number): Promise<DocumentsCountResponse> {
        return this.requestClient.get(`${Urls.GetDocumentsCountForEntity}/${entityId}/${entityTypeId}`, { });
    }

    public getAttachmentTypes(): Promise<AttachmentTypeModel[]> {
        return this.requestClient.get(`${Urls.GetAttachmentTypes}`, { });
    }
}
